angular.module('impactx.ruleset').controller('RuleProductCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'ToolbarService',
    RuleProductCtrl
]);

function RuleProductCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, ToolbarService) {
    var self = this;
    $scope.vCatArray = [{field: "vCatId", value: 0}];

    dataGen.getData($scope, {
        id: $routeParams.id,
        ruleSetId: $routeParams.ruleSetId,
        ruleType: $routeParams.ruleType
    }, "/ruleset/viewproductrule").then(function () {
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');

        defineButtons();
    });

    self.save = function () {
        return dataGen.postAsForm($scope, {formData: $scope.data}, "/ruleset/saveproductrule").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.changeCatalog = function (selected) {
        if (selected != null) {
            $scope.vCatArray[0].value = selected.id;
        }
        else {
            $scope.vCatArray[0].value = 0;
        }
    };

    self.showProductCompany = function () {
        var selectedProductRuleType = impactX.isDefined($scope.data.product.productRuleType, "selected.id");
        return selectedProductRuleType !== 3;
    };

    self.showProductGroup = function () {
        var selectedProductRuleType = impactX.isDefined($scope.data.product.productRuleType, "selected.id");
        return selectedProductRuleType === 1 && impactX.isDefined($scope.data.product.catalog, "selected.id");
    };

    self.showCatalog = function () {
        var selectedProductRuleType = impactX.isDefined($scope.data.product.productRuleType, "selected.id");
        return selectedProductRuleType === 1 || selectedProductRuleType === 3;
    };

    self.delete = function () {
        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/ruleset/deleterule").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}